import React from 'react';
import { motion } from 'framer-motion';
import { Upload } from 'lucide-react';
import { Button } from './ui/Button';
export function CTASection() {
  return <section className="relative py-24 overflow-hidden" data-id="element-156">
      {/* SVG ClipPath Definition */}
      <svg className="absolute w-0 h-0" aria-hidden="true" data-id="element-157">
        <defs data-id="element-158">
          <clipPath id="ctaClipPath" clipPathUnits="objectBoundingBox" data-id="element-159">
            <path d="M0,0 L1,0 L1,0.85 L0.85,1 L0,1 Z" data-id="element-160" />
          </clipPath>
        </defs>
      </svg>

      {/* Background gradient - true blue */}
      <div className="absolute inset-0" style={{
      background: 'linear-gradient(135deg, rgb(55, 69, 134) 0%, rgb(63, 88, 153) 40%, rgb(90, 111, 173) 100%)'
    }} data-id="element-161" />

      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none" data-id="element-162">
        <div className="absolute inset-0 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-163" />
      </div>

      {/* Subtle decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl" data-id="element-164" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full blur-3xl" data-id="element-165" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8" data-id="element-166">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-167">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-168">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6 leading-tight" style={{
            fontFamily: "'Poppins', sans-serif"
          }} data-id="element-169">
              Ready to find your next opportunity?
            </h2>
            <p className="text-xl text-blue-100/90 mb-8 leading-relaxed font-light" style={{
            fontFamily: "'Poppins', sans-serif"
          }} data-id="element-170">
              Whether you're searching for your next career move or looking to
              explore new possibilities, we're here to help you take the next
              step.
            </p>

            <div className="flex flex-wrap gap-4 mb-10" data-id="element-171">
              <Button variant="primary" size="sm" icon style={{
              fontFamily: "'Poppins', sans-serif"
            }} data-id="element-172">
                Submit Your CV
              </Button>
              <Button variant="white" size="sm" style={{
              fontFamily: "'Poppins', sans-serif"
            }} data-id="element-173">
                Search Jobs
              </Button>
            </div>
          </motion.div>

          {/* Right - Image with rounded corners */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative hidden lg:block" data-id="element-174">
            <div className="relative overflow-hidden shadow-2xl" style={{
            borderRadius: '16px'
          }} data-id="element-175">
              <img src="https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=600&q=80" alt="Healthcare team" className="w-full aspect-[4/3] object-cover" data-id="element-176" />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent" data-id="element-177" />
            </div>

            {/* Floating stat card */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="absolute -bottom-6 -left-6 bg-white rounded-xl p-6 shadow-2xl" data-id="element-178">
              <div className="text-4xl text-[#1e56a0]" style={{
              fontFamily: "'Poppins', sans-serif"
            }} data-id="element-179">
                <span className="font-bold text-[#1e3a5f]" data-id="element-180">24</span>
                <span className="font-medium text-[#4a90c2]" data-id="element-181">hours</span>
              </div>
              <div className="text-sm text-gray-600 font-light" style={{
              fontFamily: "'Poppins', sans-serif"
            }} data-id="element-182">
                Average response time
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}